import { render, staticRenderFns } from "./CreditsTable.vue?vue&type=template&id=15c9cb03"
import script from "./CreditsTable.vue?vue&type=script&lang=js"
export * from "./CreditsTable.vue?vue&type=script&lang=js"
import style0 from "./CreditsTable.vue?vue&type=style&index=0&id=15c9cb03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports